// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"bf0a22d9","206":"a53fc12e","281":"7f481dd5","453":"6e9fb57d","619":"6a738b8d","684":"1f21421a","738":"265253ca","909":"8730f86f"}[chunkId] + ".chunk.js";
};